module.exports = __webpack_public_path__ + "img/744.983f7427.png";